var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99938 13.0033C5.73338 13.0033 5.47837 12.8982 5.29138 12.7102L1.29238 8.70625C0.902375 8.31525 0.902375 7.68225 1.29338 7.29125C1.68438 6.90225 2.31738 6.90125 2.70838 7.29225L5.99938 10.5883L13.2954 3.29325C13.6864 2.90225 14.3184 2.90225 14.7094 3.29325C15.1004 3.68425 15.1004 4.31625 14.7094 4.70725L6.70638 12.7102C6.51938 12.8982 6.26538 13.0033 5.99938 13.0033Z",
    fill: "#5FDDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c5f7857c2def287b4ac78299d9860eae.svg";
export { ForwardRef as ReactComponent };